import { gql } from '@eti/schema-types';

export const ADD_TO_CART = gql(/* GraphQL */ `
  mutation addToCart(
    $selectionKey: String!
    $contactInformation: ContactInformationInput!
    $emergencyContactInformation: EmergencyContactInformationInput
    $extraProductSelection: [ExtraProductSelectionInput]!
    $ancillaryBundleSelection: [BundleSelectionInput]
    $travelers: [TravelerInput]!
    $travelSeller: TravelSellerInput
    $subscribeToNewsletter: Boolean!
  ) {
    addToCart(
      selectionKey: $selectionKey
      contactInformation: $contactInformation
      emergencyContactInformation: $emergencyContactInformation
      extraProductSelection: $extraProductSelection
      ancillaryBundleSelection: $ancillaryBundleSelection
      travelers: $travelers
      travelSeller: $travelSeller
      subscribeToNewsletter: $subscribeToNewsletter
    ) {
      success
    }
  }
`);

export const CANCEL_MAKE_ORDER_MUTATION = gql(/* GraphQL */ `
  mutation CancelMakeOrder {
    cancelMakeOrder {
      success
    }
  }
`);
